<template>
  <div
    class="bookChapter"
    v-wechat-title="
      ($route.meta.title = bookinfo.name
        ? bookinfo.name + '-章节-源石阅读'
        : '源石阅读')
    "
  >
    <Header></Header>
    <div class="container" v-bind:style="{ minHeight: minheight + 'px' }">
      <div class="breadlist clearfix">
        <img class="fl" src="~img/direction.png" alt="" />
        <a href="javaScript:" @click="gohome">首页</a>
        <span> > </span>
        <a href="javaScript:" @click="godetail">{{ bookinfo.name }}详情页</a>
        <span> > </span>
        <a href="javaScript:">{{ chapterName }}</a>
        <span class="blue">正在阅读</span>
      </div>

      <!-- 章节内容 -->
      <div class="page">
        <div class="bookhint" @click="useraddshelf" v-if="!bookinfo.isShelf">
          收藏本书
        </div>
        <div @click="getpreChpater" v-if="preid !== '0'" class="getpre">
          上一章
        </div>
        <div
          class="pagecontent"
          v-for="chapter in chapterList"
          :key="chapter.id"
        >
          <h4>
            {{ chapter.name }}
          </h4>
          <div class="chapterelse">
            作者：{{ authorinfo.name }} | 发布时间：{{ chapter.publishTime }} |
            字数：{{ chapter.words }} | 浏览：{{ chapter.visitorNum }}人
          </div>
          <div class="content" v-html="chapter.content"></div>
          <div class="paybox" v-if="!chapter.free && chapter.payment != null">
            <p class="authorhint">支持原创，为作者加油哦！</p>
            <p class="payment">当前章节：{{ chapter.payment.price }}源币</p>
            <p class="moneynum">
              账户书币：{{ chapter.payment.balance.money }}源币 |
              {{ chapter.payment.balance.coin }}赠币
            </p>
            <button
              @click="
                buyOption(
                  chapter.payment.code,
                  chapter.id,
                  chapter.payment.price
                )
              "
            >
              {{
                chapter.payment.code == 10027 ? "点击购买" : chapter.payment.dsc
              }}</button
            ><br />
            <input
              type="checkbox"
              v-model="isAutoBuy"
              @change="isOpenAuto(chapter.id)"
            />开启自动订阅
            <p class="payhint">
              自动订阅，选择后自动购买vip章节，阅读更流畅哦~
            </p>
            <!--  <p class="payhint">
              此章节为vip章节，请到www.heiyan.com网站继续阅读内容~~~
            </p> -->
          </div>
          <!-- <div class="reward" v-if="chapter.free">
            赏
          </div> -->
        </div>
      </div>
    </div>
    <div class="fixedbox">
      <a
        href="javaScript:"
        @click="gocatalog"
        class="fixitem golist"
        v-if="btnFlag"
      >
        <img src="~img/book/list.svg" alt="" />
        <p>目录</p>
      </a>
      <a
        href="javaScript:"
        @click="goCollect"
        class="fixitem gocollect"
        v-if="btnFlag"
      >
        <img src="~img/book/bookShelf.svg" alt="" />
        <p>书架</p>
      </a>
      <a
        href="javaScript:"
        @click="backTop"
        class="gotop fixitem"
        v-if="btnFlag"
      >
        <img src="~img/book/top.svg" alt="" />
        <p>顶部</p>
      </a>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import {
  chapterCon,
  addshelf,
  buyChapter,
  chapternoCon,
  addreadhistory,
  chapterVisitor,
  buyAuto,
  readstatus,
  BookDetail
} from "apiurl/book";
import { getToken } from "utils/storage";
export default {
  data() {
    return {
      chapterList: [],
      authorinfo: {},
      bookinfo: { isShelf: true },
      nextid: null,
      preid: null,
      prefree: null,
      nextfree: null,
      stop: false,
      chapterName: "",
      hisCur: 1,
      btnFlag: true,
      minheight: null,
      scrollTop: 0,
      visitor: 0,
      isAutoBuy: false //是否开启自动订阅
    };
  },
  created() {
    this.$nextTick(() => {
      this.chapterList = [];
      this.BookDetailInfo(this.$route.params.id);
      if (localStorage.getItem("isfree") == "true") {
        localStorage.removeItem("isfree");
        this.getCon(this.$route.params.id, this.$route.params.chapterid)
          .then(() => {
            this.addHistory(
              this.$route.params.id,
              this.$route.params.chapterid
            );
            /*====下拉触底加载监听*/
            $(window).on("scroll", this.scrollbottom);
          })
          .catch(() => {});
      } else {
        localStorage.removeItem("isfree");
        this.getnoFreeCon(this.$route.params.id, this.$route.params.chapterid)
          .then(() => {
            /*====下拉触底加载监听*/
            this.addHistory(
              this.$route.params.id,
              this.$route.params.chapterid
            );
            $(window).on("scroll", this.scrollbottom);
          })
          .catch(() => {});
      }
    });
  },
  methods: {
    gohome() {
      this.$router.push("/");
    },
    // 获取书籍详情信息
    async BookDetailInfo(id) {
      let res = await BookDetail(id);
      this.bookinfo = res.data.book;
      if (getToken()) {
        this.getAutoBuy();
      }
    },
    async getAutoBuy() {
      let res = await readstatus({ bookId: this.$route.params.id });
      if (res.success) {
        this.isAutoBuy = res.data.isAuto;
        this.$set(this.bookinfo, "isShelf", res.data.isShelf);
      }
    },
    godetail() {
      this.$router.push(`/bookdetail/${this.$route.params.id}`);
    },
    // 获取章节内容
    async getCon(bookId, chapterId) {
      let res = await chapterCon({ bookId, chapterId });
      if (res.success) {
        this.chapterList.push(res.data.chapter);
        this.getVisitor(this.$route.params.chapterid);
        if (res.data.chapter.nextChapter) {
          this.stop = true;
          this.nextid = res.data.chapter.nextChapter.id;
          this.nextfree = res.data.chapter.nextChapter.free;
        } else {
          this.nextid = "0";
        }
        if (res.data.chapter.preChapter) {
          this.preid = res.data.chapter.preChapter.id;
          this.prefree = res.data.chapter.preChapter.free;
        } else {
          this.preid = "0";
        }
        this.authorinfo = res.data.author;
        this.chapterName = res.data.chapter.name;
      }
    },
    // 获取非免费或不确定章节内容
    async getnoFreeCon(bookId, chapterId) {
      let res = await chapternoCon({ bookId, chapterId });
      if (res.success) {
        this.chapterList.push(res.data.chapter);
        this.getVisitor(this.$route.params.chapterid);
        if (res.data.chapter.payment) {
          this.stop = false;
        }
        if (res.data.chapter.nextChapter) {
          this.stop = true;
          this.nextid = res.data.chapter.nextChapter.id;
          this.nextfree = res.data.chapter.nextChapter.free;
        } else {
          this.nextid = "0";
        }
        if (res.data.chapter.preChapter) {
          this.preid = res.data.chapter.preChapter.id;
          this.prefree = res.data.chapter.preChapter.free;
        } else {
          this.preid = "0";
        }
        this.authorinfo = res.data.author;
        this.chapterName = res.data.chapter.name;
      }
    },
    // 加入书架
    async useraddshelf() {
      let res = await addshelf({ bookId: this.$route.params.id });
      if (res.success) {
        this.bookinfo.isShelf = true;
        this.$message({
          message: "已成功加入书架",
          type: "success"
        });
      }
    },
    // 滚动加载
    scrollbottom() {
      var totalheight =
        parseFloat($(window).height()) + parseFloat($(window).scrollTop());

      /*===回到顶部*/
      /* if($(window).scrollTop()>0){
                                                        this.isgoTop = true
                                                      }else{
                                                        this.isgoTop = false
                                                      } */
      /*====触底加载*/
      if ($(document).height() - 200 <= totalheight) {
        if (this.stop && this.nextid != "0") {
          this.stop = false;
          if (this.nextfree) {
            chapterCon({
              bookId: this.$route.params.id,
              chapterId: this.nextid
            })
              .then(res => {
                if (res.success) {
                  this.chapterList.push(res.data.chapter);
                  this.getVisitor(this.nextid);
                  this.chapterName = res.data.chapter.name;
                  this.addHistory(this.$route.params.id, this.nextid);
                  this.$nextTick(() => {
                    if (res.data.chapter.nextChapter != null) {
                      this.nextid = res.data.chapter.nextChapter.id;
                      this.nextfree = res.data.chapter.nextChapter.free;
                      this.stop = true;
                    } else {
                      $(window).off("scroll");
                    }
                  });
                }
              })
              .catch(() => {});
          } else {
            if (!getToken()) {
              localStorage.setItem(
                "vip",
                `/book/${this.$route.params.id}/${this.nextid}`
              );
            }
            chapternoCon({
              bookId: this.$route.params.id,
              chapterId: this.nextid
            })
              .then(res => {
                if (res.success) {
                  this.chapterList.push(res.data.chapter);
                  this.getVisitor(this.nextid);
                  this.chapterName = res.data.chapter.name;
                  this.addHistory(this.$route.params.id, this.nextid);
                  this.$nextTick(() => {
                    if (res.data.chapter.nextChapter != null) {
                      this.nextid = res.data.chapter.nextChapter.id;
                      this.nextfree = res.data.chapter.nextChapter.free;
                      this.stop = true;
                      if (res.data.chapter.payment) {
                        this.stop = false;
                      }
                    } else {
                      $(window).off("scroll");
                    }
                  });
                }
              })
              .catch(() => {});
          }
        }
      }
    },
    // 点击获取上一章
    async getpreChpater() {
      if (this.preid !== "0") {
        if (this.prefree) {
          let res = await chapterCon({
            bookId: this.$route.params.id,
            chapterId: this.preid
          });
          this.addHistory(this.$route.params.id, this.preid);
          this.chapterList.unshift(res.data.chapter);
          this.getVisitor(this.preid);
          this.chapterName = res.data.chapter.name;
          if (res.data.chapter.preChapter == null) {
            this.preid = "0";
          } else {
            this.preid = res.data.chapter.preChapter.id;
            this.prefree = res.data.chapter.preChapter.free;
          }
        } else {
          let res = await chapternoCon({
            bookId: this.$route.params.id,
            chapterId: this.preid
          });
          this.addHistory(this.$route.params.id, this.preid);
          this.chapterList.unshift(res.data.chapter);
          this.getVisitor(this.preid);
          this.chapterName = res.data.chapter.name;
          if (res.data.chapter.preChapter == null) {
            this.preid = "0";
          } else {
            this.preid = res.data.chapter.preChapter.id;
            this.prefree = res.data.chapter.preChapter.free;
          }
          if (res.data.chapter.payment != null) {
            this.stop = false;
          }
        }
      }
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      /* if (that.scrollTop > 80) {
                          that.btnFlag = true;
                        } else {
                          that.btnFlag = false;
                        } */
    },
    // 去我的书架
    goCollect() {
      this.$router.push("/personal/collect");
    },
    // 去目录
    gocatalog() {
      this.$router.push(`/list/${this.bookinfo.id}`);
    },
    // 收费内容判断
    buyOption(code, id, price) {
      if (code == 6000012) {
        this.$router.push({
          path: `/personal/myAccount`,
          query: { redirect: location.hostname }
        });
      } else if (code == 10027) {
        buyChapter({ chapterId: id, price: price }).then(res => {
          if (res.success) {
            this.stop = true;
            this.chapterList.forEach(item => {
              if (item.id == id) {
                item.content = res.data.chapter.content;
                item.payment = null;
              }
            });
          }
        });
      }
    },
    //添加历史记录
    addHistory(bookId, chapterId) {
      if (getToken()) {
        addreadhistory({
          bookId: bookId,
          chapterId: chapterId
        });
      }
    },
    // 获取章节浏览数
    getVisitor(chapterId) {
      chapterVisitor({ chapterId }).then(res => {
        if (res.success) {
          this.chapterList.forEach(item => {
            if (item.id == res.data.id) {
              item.visitorNum = res.data.visitors;
            }
          });
        }
      });
    },
    // 是否开启自动订阅
    isOpenAuto() {
      if (this.isAutoBuy) {
        buyAuto({ bookId: this.bookinfo.id, open: true }).then(res => {
          this.isAutoBuy = true;
          if (res.success) {
            this.$message({
              message: "自动订阅已开启",
              type: "success"
            });
            this.stop = true;
            this.chapterList.forEach(item => {
              if (item.payment) {
                chapternoCon({
                  bookId: this.$route.params.id,
                  chapterId: item.id
                }).then(book => {
                  if (book.success) {
                    item.content = book.data.chapter.content;
                    item.payment = book.data.chapter.payment || null;
                  }
                });
              }
            });
          }
        });
      } else {
        buyAuto({ bookId: this.bookinfo.id, open: false }).then(res => {
          if (res.success) {
            this.$message({
              message: "自动订阅已关闭",
              type: "success"
            });
          }
        });
      }
    }
  },
  beforeDestroy() {
    $(window).off("scroll");
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
    this.minheight = document.documentElement.clientHeight - 290; //监听浏览器窗口变化
    window.onresize = () => {
      this.minheight = document.documentElement.clientHeight - 290;
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  }
};
</script>
<style lang="stylus" scoped>
.container
    margin 0 auto
    width 1016px
    .breadlist
        height 48px
        line-height 48px
        color #414141
        font-size 14px
        img
            width 16px
            height 16px
            margin-top 16px
            margin-right 5px
        a
            color #414141
            font-size 14px
        .blue
            color #48A2DF
            margin-left 5px
    .page
        color #333333
        font-size 14px
        line-height 30px
        padding 0 0 46px
        position relative
        .bookhint
            position absolute
            left 0
            width 74px
            height 26px
            line-height 26px
            background rgba(72, 162, 223, 1)
            border-radius 0 13px 13px 0px
            top 32px
            font-size 14px
            font-weight 400
            color #ffffff
            text-align center
            cursor pointer
        .getpre
            border-radius 13px 0 0 13px
            right 0px
            position absolute
            width 74px
            height 26px
            line-height 26px
            background rgba(72, 162, 223, 1)
            top 32px
            font-size 14px
            font-weight 400
            color #ffffff
            text-align center
            cursor pointer
        .pagecontent
            background rgba(247, 254, 255, 1)
            margin-bottom 20px
            padding-top 24px
            padding-bottom 24px
            &:first-child
                padding-top 30px
            h4
                text-align center
                font-size 28px
                font-weight 600
            .chapterelse
                text-align center
                font-size 12px
                color rgba(153, 153, 153, 1)
                line-height 17px
                margin 10px 0 23px
            .content
                padding 0 46px 0 36px
                line-height 30px
                text-indent 20px
            .paybox
                margin 36px 46px 0px 36px
                padding-top 46px
                border-top 1px dashed #BAE3FF
                text-align center
                font-size 14px
                color #2E2E2E
                .authorhint
                    font-size 24px
                    color #999
                    text-align center
                    margin-bottom 27px
                .payment
                    margin-bottom 10px
                .moneynum
                    margin-bottom 19px
                button
                    width 153px
                    height 35px
                    background rgba(72, 162, 223, 1)
                    border-radius 4px
                    font-size 14px
                    color #fff
                    border none
                    border-radius 4px
                input
                    margin-right 5px
                .payhint
                    font-size 10px
                    color #555555
            .reward
                width 90px
                height 90px
                background rgba(255, 178, 51, 1)
                font-size 30px
                color rgba(255, 255, 255, 1)
                text-align center
                line-height 90px
                border-radius 50%
                margin 30px auto 46px
</style>
